var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.$style.link,attrs:{"to":"/"},nativeOn:{"click":function($event){return _vm.$nc($event, 'gnb.logo')}}},[_c('img',{class:_vm.$style.logo,attrs:{"src":"/assets/img/WhaleSpace_dev_logo_2x.png","alt":"WhaleSpace"}})])}
var staticRenderFns = []

export { render, staticRenderFns }